<ng-container
    *ngIf="
        workflow?.delegatedAuthority != null ||
        (showAdditionalAuthorities &&
            additionalAuthorityIds != null &&
            additionalAuthorityIds.length > 0)
    "
>
    <h4 class="inline-heading" style="margin-top: 5px">Authorities in Use</h4>
    <div class="vertical-container approval-data">
        <span
            *ngIf="workflow?.delegatedAuthority?.authorityType?.ruleset != null"
            class="bottom-buffer"
            ><strong>Ruleset</strong>
            {{ workflow.delegatedAuthority.authorityType.ruleset.name }}
        </span>
        <span *ngIf="workflow?.delegatedAuthority">
            <div>
                <span
                    *ngIf="
                        authorityIndicatorLookup &&
                        authorityIndicatorLookup[
                            workflow?.delegatedAuthority.id
                        ]
                    "
                    class="circle-indicator"
                    style="margin-right: 5px"
                >
                    {{
                        authorityIndicatorLookup[workflow.delegatedAuthority.id]
                    }}
                </span>
                <strong>Workflow Primary Authority</strong>
                <span
                    *ngIf="workflow.delegatedAuthority.requiresApproval"
                    class="badge badge-active"
                    style="margin-left: 5px"
                    >Approval</span
                >
            </div>
            {{ (workflow.delegatedAuthority | formatAuthority) || 'None' }}
            <button
                *ngIf="
                    missionWorkflowPrimaryAuthority != null &&
                    missionWorkflowPrimaryAuthority.availableActions.canEdit
                "
                type="button"
                class="btn btn-link btn-sm"
                style="padding: 0 5px; margin: 0; line-height: 22px"
                (click)="showAuthorityDetails(workflow?.delegatedAuthority)"
                [disabled]="
                    setDisabled || missionWorkflowPrimaryAuthority == null
                "
            >
                Details
            </button>
        </span>
    </div>
    <div
        *ngFor="let additionalAuthority of workflow?.additionalAuthorities"
        class="vertical-container approval-data"
    >
        <div *ngIf="additionalAuthority == null" class="fill">
            <span class="status-block expired">Authority not available</span>
        </div>
        <div
            *ngIf="additionalAuthority != null && availableAuthorityLookup != null"
            class="fill"
        >
            <div>
                <span
                    *ngIf="
                        authorityIndicatorLookup &&
                        authorityIndicatorLookup[additionalAuthority.id]
                    "
                    class="circle-indicator"
                    style="margin-right: 5px"
                >
                    {{ authorityIndicatorLookup[additionalAuthority.id] }}
                </span>
                <strong>Workflow Additional Authority</strong>
                <span
                    *ngIf="additionalAuthority.requiresApproval"
                    class="badge badge-active"
                    style="margin-left: 5px"
                    >Approval</span
                >
            </div>
            {{ availableAuthorityLookup[additionalAuthority.id]?.name }}
            <button
                *ngIf="
                    missionWorkflowPrimaryAuthority != null &&
                    missionWorkflowPrimaryAuthority.availableActions.canEdit
                "
                type="button"
                class="btn btn-link btn-sm"
                style="padding: 0 5px; margin: 0; line-height: 22px"
                (click)="showAuthorityDetails(additionalAuthority)"
                [disabled]="setDisabled"
            >
                Details
            </button>
        </div>
    </div>
    <ng-container
        *ngIf="
            showAdditionalAuthorities &&
            additionalAuthorityIds != null &&
            additionalAuthorityIds.length > 0
        "
    >
        <div
            *ngFor="let additionalAuthorityId of additionalAuthorityIds"
            class="vertical-container approval-data"
        >
            <div
                *ngIf="
                    allAdditionalAuthoritiesLookup &&
                    allAdditionalAuthoritiesLookup[additionalAuthorityId] ==
                        null
                "
                class="fill"
            >
                <span class="status-block expired"
                    >Authority not available</span
                >
            </div>
            <div
                *ngIf="
                    allAdditionalAuthoritiesLookup &&
                    allAdditionalAuthoritiesLookup[additionalAuthorityId] !=
                        null &&
                    availableAuthorityLookup &&
                    availableAuthorityLookup[additionalAuthorityId] != null
                "
                class="fill"
            >
                <div>
                    <span
                        *ngIf="
                            authorityIndicatorLookup &&
                            authorityIndicatorLookup[additionalAuthorityId]
                        "
                        class="circle-indicator"
                        style="margin-right: 5px"
                    >
                        {{ authorityIndicatorLookup[additionalAuthorityId] }}
                    </span>
                    <strong>Additional Authority</strong>
                    <span
                        *ngIf="
                            allAdditionalAuthoritiesLookup &&
                            allAdditionalAuthoritiesLookup[
                                additionalAuthorityId
                            ].requiresApproval
                        "
                        class="badge badge-active"
                        style="margin-left: 5px"
                        >Approval</span
                    >
                </div>
                {{ availableAuthorityLookup[additionalAuthorityId].name }}
                <button
                    *ngIf="
                        missionWorkflowPrimaryAuthority != null &&
                        missionWorkflowPrimaryAuthority.availableActions.canEdit
                    "
                    type="button"
                    class="btn btn-link btn-sm"
                    style="padding: 0 5px; margin: 0; line-height: 22px"
                    (click)="
                        showAuthorityDetails(
                            allAdditionalAuthoritiesLookup[
                                additionalAuthorityId
                            ]
                        )
                    "
                    [disabled]="working || locked"
                >
                    Details
                </button>
            </div>
        </div>
    </ng-container>
</ng-container>
